module.exports = {
	projects: [
		{
			title: "codeportal",
			id: "codeportal",
			path: "/projects/codeportal",
			description:
				"First of it's kind in Manipal, a place where IECSE hosts its coding competitions.",
			link: "https://code.iecse-manipal.com",
			mobileImg: "",
			desktopImg: "",
			techStack: [
				{
					name: "React",
					link: "https://reactjs.org/",
					logo:
						"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
					description:
						"React is an open-source, front end, JavaScript library for building user interfaces or UI components. It is maintained by Facebook and a community of individual developers and companies. React can be used as a base in the development of single-page or mobile applications.",
					color: "#61DAFB",
					font_color: "#005E78",
				},
				{
					name: "Redux",
					link: "https://redux.js.org/",
					logo: "https://redux.js.org/img/redux.svg",
					description:
						"Redux is an open-source JavaScript library for managing application state. It is most commonly used with libraries such as React or Angular for building user interfaces. Similar to Facebook's Flux architecture, it was created by Dan Abramov and Andrew Clark and released in 2015.",
					color: "#764ABC",
					font_color: "#FFFFFF",
				},
				{
					name: "NodeJS",
					link: "https://nodejs.org/en/docs/",
					logo:
						"https://nodejs.org/static/images/logos/nodejs-new-pantone-black.svg",
					description:
						"Node.js is an open-source, cross-platform, back-end, JavaScript runtime environment that executes JavaScript code outside a web browser.",
					color: "#6ABF4B",
					font_color: "#000000",
				},
				{
					name: "Express",
					link: "https://expressjs.com/",
					logo:
						"https://raw.githubusercontent.com/singhdipesh14/techLogosforMainWebsite/c699fdd582fe3188e46a083b2aa23a5e0ad4df56/express.svg",
					description:
						"Express.js, or simply Express, is a back end web application framework for Node.js. It is designed for building web applications and APIs. It has been called the de facto standard server framework for Node.js.",
					color: "#252525",
					font_color: "#FFFFFF",
				},
				{
					name: "MySQL",
					link: "https://www.mysql.com/",
					logo:
						"https://raw.githubusercontent.com/singhdipesh14/techLogosforMainWebsite/c699fdd582fe3188e46a083b2aa23a5e0ad4df56/mysql.svg",
					description:
						"SQL, Structured Query Language is a domain-specific language used in programming and designed for managing data held in a relational database management system, or for stream processing in a relational data stream management system.",
					color: "#4479A1",
					font_color: "#FFFFFF",
				},
				{
					name: "GoLang",
					link: "https://golang.org/",
					logo:
						"https://golang.org/lib/godoc/images/go-logo-blue.svg",
					description:
						"Go is a statically typed, compiled programming language designed at Google by Robert Griesemer, Rob Pike, and Ken Thompson released in 2009. Go is syntactically similar to C, but with memory safety, garbage collection, structural typing, and CSP-style concurrency.",
					color: "#00ACD7",
					font_color: "#FFFFFF",
				},
			],
		},
		{
			title: "aether",
			id: "aether",
			link:
				"https://play.google.com/store/apps/details?id=com.iecsemanipal.aethermastered",
			path: "/projects/aether",
			mobileImg: "",
			desktopImg: "",
			description:
				"The mobile version of the Member's Portal, providing even greater accessibility.",
			techStack: [
				{
					name: "Flutter",
					link: "https://flutter.dev/",
					logo:
						"https://flutter.dev/assets/flutter-lockup-1caf6476beed76adec3c477586da54de6b552b2f42108ec5bc68dc63bae2df75.png",
					description:
						"Flutter is an open-source UI software development kit created by Google. It is used to develop applications for Android, iOS, Linux, Mac, Windows, Google Fuchsia, and the web from a single codebase.",
					color: "#075B9A",
					font_color: "#FFFFFF",
				},
				{
					name: "NodeJS",
					link: "https://nodejs.org/en/docs/",
					logo:
						"https://nodejs.org/static/images/logos/nodejs-new-pantone-black.svg",
					description:
						"Node.js is an open-source, cross-platform, back-end, JavaScript runtime environment that executes JavaScript code outside a web browser.",
					color: "#6ABF4B",
					font_color: "#000000",
				},
				{
					name: "Express",
					link: "https://expressjs.com/",
					logo:
						"https://raw.githubusercontent.com/singhdipesh14/techLogosforMainWebsite/c699fdd582fe3188e46a083b2aa23a5e0ad4df56/express.svg",
					description:
						"Express.js, or simply Express, is a back end web application framework for Node.js. It is designed for building web applications and APIs. It has been called the de facto standard server framework for Node.js.",
					color: "#252525",
					font_color: "#FFFFFF",
				},
				{
					name: "MySQL",
					link: "https://www.mysql.com/",
					logo:
						"https://raw.githubusercontent.com/singhdipesh14/techLogosforMainWebsite/c699fdd582fe3188e46a083b2aa23a5e0ad4df56/mysql.svg",
					description:
						"SQL, Structured Query Language is a domain-specific language used in programming and designed for managing data held in a relational database management system, or for stream processing in a relational data stream management system.",
					color: "#4479A1",
					font_color: "#FFFFFF",
				},
				{
					name: "Firebase",
					link: "https://firebase.google.com/",
					logo:
						"https://www.gstatic.com/devrel-devsite/prod/v82ddc984cee1a5dd6ee4c16cb38492e67eefd500032375cc23778d6489eec4cb/firebase/images/lockup.png",
					description:
						"Firebase is a Backend-as-a-Service (Baas). It provides developers with a variety of tools and services to help them develop quality apps, grow their user base, and earn profit. It is built on Google’s infrastructure.",
					color: "#FBC02D",
					font_color: "#242424",
				},
			],
		},
		{
			title: "aether web",
			id: "aetherweb",
			path: "/projects/aetherweb",
			link: "https://members.iecse-manipal.com",
			mobileImg: "",
			desktopImg: "",
			description:
				"A one-stop-shop for all the members of IECSE - Archive, Hashtag, and Events",
			techStack: [
				{
					name: "React",
					link: "https://reactjs.org/",
					logo:
						"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
					description:
						"React is an open-source, front end, JavaScript library for building user interfaces or UI components. It is maintained by Facebook and a community of individual developers and companies. React can be used as a base in the development of single-page or mobile applications.",
					color: "#61DAFB",
					font_color: "#005E78",
				},
				{
					name: "MobX",
					link: "https://mobx-state-tree.js.org/intro/philosophy",
					logo: "https://mobx.js.org/img/mobx.png",
					description:
						"MobX is a battle-tested library that makes state management simple and scalable by transparently applying functional reactive programming (TFRP).",
					color: "#EC681A",
					font_color: "#FFFFFF",
				},
				{
					name: "TypeScript",
					link: "https://www.typescriptlang.org/",
					logo:
						"https://raw.githubusercontent.com/singhdipesh14/techLogosforMainWebsite/c699fdd582fe3188e46a083b2aa23a5e0ad4df56/typescript.svg",
					description:
						"TypeScript is a programming language developed and maintained by Microsoft. It is a strict syntactical superset of JavaScript and adds optional static typing to the language. TypeScript is designed for development of large applications and transcompiles to JavaScript.",
					color: "#3178C6",
					font_color: "#FFFFFF",
				},
				{
					name: "NodeJS",
					link: "https://nodejs.org/en/docs/",
					logo:
						"https://nodejs.org/static/images/logos/nodejs-new-pantone-black.svg",
					description:
						"Node.js is an open-source, cross-platform, back-end, JavaScript runtime environment that executes JavaScript code outside a web browser.",
					color: "#6ABF4B",
					font_color: "#000000",
				},
				{
					name: "Express",
					link: "https://expressjs.com/",
					logo:
						"https://raw.githubusercontent.com/singhdipesh14/techLogosforMainWebsite/c699fdd582fe3188e46a083b2aa23a5e0ad4df56/express.svg",
					description:
						"Express.js, or simply Express, is a back end web application framework for Node.js. It is designed for building web applications and APIs. It has been called the de facto standard server framework for Node.js.",
					color: "#252525",
					font_color: "#FFFFFF",
				},
				{
					name: "MySQL",
					link: "https://www.mysql.com/",
					logo:
						"https://raw.githubusercontent.com/singhdipesh14/techLogosforMainWebsite/c699fdd582fe3188e46a083b2aa23a5e0ad4df56/mysql.svg",
					description:
						"SQL, Structured Query Language is a domain-specific language used in programming and designed for managing data held in a relational database management system, or for stream processing in a relational data stream management system.",
					color: "#4479A1",
					font_color: "#FFFFFF",
				},
			],
		},
		{
			title: "hotstreaks",
			id: "hotstreaks",
			path: "/projects/hotstreaks",
			link: "https://hotstreaks.iecse-manipal.com",
			mobileImg: "",
			desktopImg: "",
			description:
				"A web app for a coding competition with implemented powers to give you an edge over your competition, as you get on a streak.",
			techStack: [
				{
					name: "React",
					link: "https://reactjs.org/",
					logo:
						"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
					description:
						"React is an open-source, front end, JavaScript library for building user interfaces or UI components. It is maintained by Facebook and a community of individual developers and companies. React can be used as a base in the development of single-page or mobile applications.",
					color: "#61DAFB",
					font_color: "#005E78",
				},
				{
					name: "MobX",
					link: "https://mobx.js.org/README.html",
					logo: "https://mobx.js.org/img/mobx.png",
					description:
						"MobX is a battle-tested library that makes state management simple and scalable by transparently applying functional reactive programming (TFRP).",
					color: "#EC681A",
					font_color: "#FFFFFF",
				},
				{
					name: "NodeJS",
					link: "https://nodejs.org/en/docs/",
					logo:
						"https://nodejs.org/static/images/logos/nodejs-new-pantone-black.svg",
					description:
						"Node.js is an open-source, cross-platform, back-end, JavaScript runtime environment that executes JavaScript code outside a web browser.",
					color: "#6ABF4B",
					font_color: "#000000",
				},
				{
					name: "Express",
					link: "https://expressjs.com/",
					logo:
						"https://raw.githubusercontent.com/singhdipesh14/techLogosforMainWebsite/c699fdd582fe3188e46a083b2aa23a5e0ad4df56/express.svg",
					description:
						"Express.js, or simply Express, is a back end web application framework for Node.js. It is designed for building web applications and APIs. It has been called the de facto standard server framework for Node.js.",
					color: "#252525",
					font_color: "#FFFFFF",
				},
				{
					name: "MySQL",
					link: "https://www.mysql.com/",
					logo:
						"https://raw.githubusercontent.com/singhdipesh14/techLogosforMainWebsite/c699fdd582fe3188e46a083b2aa23a5e0ad4df56/mysql.svg",
					description:
						"SQL, Structured Query Language is a domain-specific language used in programming and designed for managing data held in a relational database management system, or for stream processing in a relational data stream management system.",
					color: "#4479A1",
					font_color: "#FFFFFF",
				},
			],
		},
		{
			title: "hawkeye",
			id: "hawkeye",
			path: "/projects/hawkeye",
			link: "https://hawkeye.iecse-manipal.com",
			mobileImg: "",
			desktopImg: "",
			description:
				"Our bi-annual online scavenger hunt, an event that makes your brain connect dots that are hiding in plain sight.",
			techStack: [
				{
					name: "React",
					link: "https://reactjs.org/",
					logo:
						"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
					description:
						"React is an open-source, front end, JavaScript library for building user interfaces or UI components. It is maintained by Facebook and a community of individual developers and companies. React can be used as a base in the development of single-page or mobile applications.",
					color: "#61DAFB",
					font_color: "#005E78",
				},
				{
					name: "MobX",
					link: "https://mobx.js.org/README.html",
					logo: "https://mobx.js.org/img/mobx.png",
					description:
						"MobX is a battle-tested library that makes state management simple and scalable by transparently applying functional reactive programming (TFRP).",
					color: "#EC681A",
					font_color: "#FFFFFF",
				},
				{
					name: "GoLang",
					link: "https://golang.org/",
					logo:
						"https://golang.org/lib/godoc/images/go-logo-blue.svg",
					description:
						"Go is a statically typed, compiled programming language designed at Google by Robert Griesemer, Rob Pike, and Ken Thompson released in 2009. Go is syntactically similar to C, but with memory safety, garbage collection, structural typing, and CSP-style concurrency.",
					color: "#00ACD7",
					font_color: "#FFFFFF",
				},
				{
					name: "MongoDB",
					link: "https://www.mongodb.com/",
					logo:
						"https://raw.githubusercontent.com/singhdipesh14/techLogosforMainWebsite/c699fdd582fe3188e46a083b2aa23a5e0ad4df56/mongodb.svg",
					description:
						"MongoDB is a cross-platform document-oriented database program developed by MongoDB Inc. Classified as a NoSQL database program, MongoDB uses JSON-like documents with optional schemas.",
					color: "#116149",
					font_color: "#FFFFFF",
				},
				{
					name: "Docker",
					link: "https://www.docker.com/",
					logo:
						"https://raw.githubusercontent.com/singhdipesh14/techLogosforMainWebsite/c699fdd582fe3188e46a083b2aa23a5e0ad4df56/docker.svg",
					description:
						"Docker is a set of platform as a service products that use OS-level virtualization to deliver software in packages called containers. Containers are isolated from one another and bundle their own software, libraries and configuration files; they can communicate with each other through well-defined channels.",
					color: "#319CEC",
					font_color: "#FFFFFF",
				},
			],
		},
		{
			title: "age of coders",
			id: "ageofcoders",
			path: "/projects/ageofcoders",
			link: "https://aoc.iecse-manipal.com",
			mobileImg: "",
			desktopImg: "",
			description:
				"This event transforms a regular old online coding contest into an Age of Empires style battle of wits.",
			techStack: [
				{
					name: "HTML",
					link: "https://developer.mozilla.org/en-US/docs/Learn/HTML",
					logo:
						"https://raw.githubusercontent.com/singhdipesh14/techLogosforMainWebsite/c699fdd582fe3188e46a083b2aa23a5e0ad4df56/html.svg",
					description:
						"HTML is the standard markup language for creating web pages. Web browsers receive HTML documents from a web server or from local storage and render the documents into multimedia web pages. HTML describes the structure of a web page semantically and originally included cues for the appearance of the document.",
					color: "#F16524",
					font_color: "#FFFFFF",
				},
				{
					name: "CSS",
					link: "https://developer.mozilla.org/en-US/docs/Learn/CSS",
					logo:
						"https://raw.githubusercontent.com/singhdipesh14/techLogosforMainWebsite/c699fdd582fe3188e46a083b2aa23a5e0ad4df56/css.svg",
					description:
						"CSS, Cascading Style Sheets is a style sheet language used for describing the presentation of a document written in a markup language such as HTML. CSS is a cornerstone technology of the World Wide Web, alongside HTML and JavaScript.",
					color: "#264DE4",
					font_color: "#FFFFFF",
				},
				{
					name: "JavaScript",
					link:
						"https://developer.mozilla.org/en-US/docs/Learn/JavaScript",
					logo:
						"https://raw.githubusercontent.com/singhdipesh14/techLogosforMainWebsite/c699fdd582fe3188e46a083b2aa23a5e0ad4df56/javascript.svg",
					description:
						"JavaScript is a high-level, often just-in-time compiled, and multi-paradigm scripting or programming language that allows you to implement complex features on the web.",
					color: "#F7DB3C",
					font_color: "#252525",
				},
				{
					name: "NodeJS",
					link: "https://nodejs.org/en/docs/",
					logo:
						"https://nodejs.org/static/images/logos/nodejs-new-pantone-black.svg",
					description:
						"Node.js is an open-source, cross-platform, back-end, JavaScript runtime environment that executes JavaScript code outside a web browser.",
					color: "#6ABF4B",
					font_color: "#000000",
				},
				{
					name: "Express",
					link: "https://expressjs.com/",
					logo:
						"https://raw.githubusercontent.com/singhdipesh14/techLogosforMainWebsite/c699fdd582fe3188e46a083b2aa23a5e0ad4df56/express.svg",
					description:
						"Express.js, or simply Express, is a back end web application framework for Node.js. It is designed for building web applications and APIs. It has been called the de facto standard server framework for Node.js.",
					color: "#252525",
					font_color: "#FFFFFF",
				},
				{
					name: "MySQL",
					link: "https://www.mysql.com/",
					logo:
						"https://raw.githubusercontent.com/singhdipesh14/techLogosforMainWebsite/c699fdd582fe3188e46a083b2aa23a5e0ad4df56/mysql.svg",
					description:
						"SQL, Structured Query Language is a domain-specific language used in programming and designed for managing data held in a relational database management system, or for stream processing in a relational data stream management system.",
					color: "#4479A1",
					font_color: "#FFFFFF",
				},
			],
		},
	],
	projects2: [
		{
			title: "mailer",
			id: "mailer",
			path: "/projects/mailer",
			description:
				"The supervising entity for every mail that IECSE sends out, from notifications to password resets.",
			techStack: [
				{
					name: "NodeJS",
					link: "https://nodejs.org/en/docs/",
					logo:
						"https://nodejs.org/static/images/logos/nodejs-new-pantone-black.svg",
					description:
						"Node.js is an open-source, cross-platform, back-end, JavaScript runtime environment that executes JavaScript code outside a web browser.",
					color: "#6ABF4B",
					font_color: "#000000",
				},
				{
					name: "Express",
					link: "https://expressjs.com/",
					logo:
						"https://raw.githubusercontent.com/singhdipesh14/techLogosforMainWebsite/c699fdd582fe3188e46a083b2aa23a5e0ad4df56/express.svg",
					description:
						"Express.js, or simply Express, is a back end web application framework for Node.js. It is designed for building web applications and APIs. It has been called the de facto standard server framework for Node.js.",
					color: "#252525",
					font_color: "#FFFFFF",
				},
				{
					name: "MySQL",
					link: "https://www.mysql.com/",
					logo:
						"https://raw.githubusercontent.com/singhdipesh14/techLogosforMainWebsite/c699fdd582fe3188e46a083b2aa23a5e0ad4df56/mysql.svg",
					description:
						"SQL, Structured Query Language is a domain-specific language used in programming and designed for managing data held in a relational database management system, or for stream processing in a relational data stream management system.",
					color: "#4479A1",
					font_color: "#FFFFFF",
				},
			],
		},
		{
			title: "judge",
			id: "judge",
			path: "/projects/judge",
			description:
				"Manages every aspect of submissions we get on the code portal. Be it scheduling or evaluating.",
			techStack: [
				{
					name: "GoLang",
					link: "https://golang.org/",
					logo:
						"https://golang.org/lib/godoc/images/go-logo-blue.svg",
					description:
						"Go is a statically typed, compiled programming language designed at Google by Robert Griesemer, Rob Pike, and Ken Thompson released in 2009. Go is syntactically similar to C, but with memory safety, garbage collection, structural typing, and CSP-style concurrency.",
					color: "#00ACD7",
					font_color: "#FFFFFF",
				},
				{
					name: "Bash",
					link: "https://devdocs.io/bash/",
					logo:
						"https://raw.githubusercontent.com/singhdipesh14/techLogosforMainWebsite/c699fdd582fe3188e46a083b2aa23a5e0ad4df56/bash.svg",
					description:
						"Bash is a Unix shell and command language written by Brian Fox for the GNU Project as a free software replacement for the Bourne shell. First released in 1989, it has been used as the default login shell for most Linux distributions and all releases of Apple's macOS prior to macOS Catalina. A version is also available for Windows 10 via the Windows Subsystem for Linux.",
					color: "#A32D2A",
					font_color: "#FFFFFF",
				},
			],
		},
		{
			title: "certman",
			id: "certman",
			path: "/projects/certman",
			description:
				"An in-house certificate generator for all kinds of certificates.",
			techStack: [
				{
					name: "NodeJS",
					link: "https://nodejs.org/en/docs/",
					logo:
						"https://nodejs.org/static/images/logos/nodejs-new-pantone-black.svg",
					description:
						"Node.js is an open-source, cross-platform, back-end, JavaScript runtime environment that executes JavaScript code outside a web browser.",
					color: "#6ABF4B",
					font_color: "#000000",
				},
				{
					name: "Express",
					link: "https://expressjs.com/",
					logo:
						"https://raw.githubusercontent.com/singhdipesh14/techLogosforMainWebsite/c699fdd582fe3188e46a083b2aa23a5e0ad4df56/express.svg",
					description:
						"Express.js, or simply Express, is a back end web application framework for Node.js. It is designed for building web applications and APIs. It has been called the de facto standard server framework for Node.js.",
					color: "#252525",
					font_color: "#FFFFFF",
				},
				{
					name: "MySQL",
					link: "https://www.mysql.com/",
					logo:
						"https://raw.githubusercontent.com/singhdipesh14/techLogosforMainWebsite/c699fdd582fe3188e46a083b2aa23a5e0ad4df56/mysql.svg",
					description:
						"SQL, Structured Query Language is a domain-specific language used in programming and designed for managing data held in a relational database management system, or for stream processing in a relational data stream management system.",
					color: "#4479A1",
					font_color: "#FFFFFF",
				},
			],
		},
	],
};
